const DATE_VALUE = /^(?:(?:mon|tue|wed|thu|fri|sat|sun),?\s+)?\d{1,4}[\s\-/T:.].{4,}$/i;

/** Same date rule as the server: a feed date is shown in the screen timezone, other text is left as published. */
const formatFeedValue = (value: string, timeZone: string): string => {
    const text = value.trim();
    if (!DATE_VALUE.test(text) || text.length > 80) return value;
    const parsed = Date.parse(text);
    if (Number.isNaN(parsed)) return value;
    try {
        return new Intl.DateTimeFormat('en-GB', {
            timeZone: timeZone || 'UTC',
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
        }).format(new Date(parsed));
    } catch {
        return value;
    }
};

/** Ticker lines from feed items: the chosen fields of each item joined, the same way the server does for screens. */
export const newsItemsFrom = (items: Array<Record<string, string>>, fields: string[], joiner: string, maxItems: number, timeZone = 'UTC'): string[] =>
    items
        .map((item) => fields.map((f) => formatFeedValue(item[f] || '', timeZone)).filter(Boolean).join(joiner))
        .filter(Boolean)
        .slice(0, maxItems);
